//存折线图数据
import { GET_CHINESE_MEDICINE_REPORT } from "./actionType";

const defaultState = {
  chineseMedicineReport: {},//中医报告
};
const Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case GET_CHINESE_MEDICINE_REPORT:
      const newState = JSON.parse (JSON.stringify ({ ...state }));
      const newReport = action.report.chineseMedicineReport;
      console.log(newReport);
      newState.chineseMedicineReport.page = newReport.page;
      // newState.chineseMedicineReport.page_count = newReport.page_count;
      newState.chineseMedicineReport.total = newReport.total;

      newState.chineseMedicineReport.data = newState.chineseMedicineReport.data && newReport.page !== 1 ?
        concatGroup (newState.chineseMedicineReport.data, newReport.list) : JSON.parse (JSON.stringify (newReport.list));
      return { ...state, ...newState };//存中医报告
    default:
      return state;
  }
};

const concatGroup = (target, array) => {
  const array1 = target ? JSON.parse (JSON.stringify (target)) : [];
  const array2 = array ? JSON.parse (JSON.stringify (array)) : [];
  return [...array1, ...array2];
};
export default Reducer;
